// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  RiskAssociation,
  RiskAssociationFromJSON,
  RiskAssociationToJSON,
  RiskScaleValue,
  RiskScaleValueFromJSON,
  RiskScaleValueToJSON,
  RiskStatus,
  RiskStatusFromJSON,
  RiskStatusToJSON,
  RiskType,
  RiskTypeFromJSON,
  RiskTypeToJSON,
  RiskVerification,
  RiskVerificationFromJSON,
  RiskVerificationToJSON,
  Tag,
  TagFromJSON,
  TagToJSON,
  User,
  UserFromJSON,
  UserToJSON,
} from "./";

/**
 *
 * @export
 * @interface Risk
 */
export interface Risk {
  /**
   *
   * @type {number}
   * @memberof Risk
   */
  id: number;
  /**
   * Per-company human-readable business number (shown as RK-12). Distinct from the internal id.
   * @type {number}
   * @memberof Risk
   */
  displayNumber?: number;
  /**
   *
   * @type {number}
   * @memberof Risk
   */
  project: number;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  description?: string;
  /**
   *
   * @type {RiskType}
   * @memberof Risk
   */
  riskType?: RiskType;
  /**
   *
   * @type {RiskStatus}
   * @memberof Risk
   */
  status: RiskStatus;
  /**
   *
   * @type {RiskScaleValue}
   * @memberof Risk
   */
  likelihood: RiskScaleValue;
  /**
   *
   * @type {RiskScaleValue}
   * @memberof Risk
   */
  impact: RiskScaleValue;
  /**
   * Computed value, likelihood.score x impact.score
   * @type {number}
   * @memberof Risk
   */
  exposure: number;
  /**
   * Categorical level the numeric exposure falls into, via configurable per-template thresholds
   * @type {string}
   * @memberof Risk
   */
  exposureBand: RiskExposureBandEnum;
  /**
   *
   * @type {User}
   * @memberof Risk
   */
  owner?: User;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  mitigationStrategy?: string;
  /**
   *
   * @type {RiskScaleValue}
   * @memberof Risk
   */
  residualLikelihood?: RiskScaleValue;
  /**
   *
   * @type {RiskScaleValue}
   * @memberof Risk
   */
  residualImpact?: RiskScaleValue;
  /**
   *
   * @type {number}
   * @memberof Risk
   */
  residualExposure?: number;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  targetDate?: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  reviewDate?: string;
  /**
   *
   * @type {Array<Tag>}
   * @memberof Risk
   */
  tags?: Array<Tag>;
  /**
   *
   * @type {Array<RiskAssociation>}
   * @memberof Risk
   */
  associations?: Array<RiskAssociation>;
  /**
   *
   * @type {RiskVerification}
   * @memberof Risk
   */
  verification?: RiskVerification;
  /**
   * Linked Azure DevOps / Jira work item id
   * @type {string}
   * @memberof Risk
   */
  externalId?: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  externalUrl?: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  issueManager?: string;
  /**
   *
   * @type {User}
   * @memberof Risk
   */
  createdBy?: User;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof Risk
   */
  updatedAt?: string;
}

export function RiskFromJSON(json: any): Risk {
  return {
    id: json["id"],
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    project: json["project"],
    title: json["title"],
    description: !exists(json, "description") ? undefined : json["description"],
    riskType: !exists(json, "risk_type")
      ? undefined
      : RiskTypeFromJSON(json["risk_type"]),
    status: RiskStatusFromJSON(json["status"]),
    likelihood: RiskScaleValueFromJSON(json["likelihood"]),
    impact: RiskScaleValueFromJSON(json["impact"]),
    exposure: json["exposure"],
    exposureBand: json["exposure_band"],
    owner: !exists(json, "owner") ? undefined : UserFromJSON(json["owner"]),
    mitigationStrategy: !exists(json, "mitigation_strategy")
      ? undefined
      : json["mitigation_strategy"],
    residualLikelihood: !exists(json, "residual_likelihood")
      ? undefined
      : RiskScaleValueFromJSON(json["residual_likelihood"]),
    residualImpact: !exists(json, "residual_impact")
      ? undefined
      : RiskScaleValueFromJSON(json["residual_impact"]),
    residualExposure: !exists(json, "residual_exposure")
      ? undefined
      : json["residual_exposure"],
    targetDate: !exists(json, "target_date") ? undefined : json["target_date"],
    reviewDate: !exists(json, "review_date") ? undefined : json["review_date"],
    tags: !exists(json, "tags")
      ? undefined
      : (json["tags"] as Array<any>).map(TagFromJSON),
    associations: !exists(json, "associations")
      ? undefined
      : (json["associations"] as Array<any>).map(RiskAssociationFromJSON),
    verification: !exists(json, "verification")
      ? undefined
      : RiskVerificationFromJSON(json["verification"]),
    externalId: !exists(json, "external_id") ? undefined : json["external_id"],
    externalUrl: !exists(json, "external_url")
      ? undefined
      : json["external_url"],
    issueManager: !exists(json, "issue_manager")
      ? undefined
      : json["issue_manager"],
    createdBy: !exists(json, "created_by")
      ? undefined
      : UserFromJSON(json["created_by"]),
    createdAt: json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function RiskToJSON(value?: Risk): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    display_number: value.displayNumber,
    project: value.project,
    title: value.title,
    description: value.description,
    risk_type: RiskTypeToJSON(value.riskType),
    status: RiskStatusToJSON(value.status),
    likelihood: RiskScaleValueToJSON(value.likelihood),
    impact: RiskScaleValueToJSON(value.impact),
    exposure: value.exposure,
    exposure_band: value.exposureBand,
    owner: UserToJSON(value.owner),
    mitigation_strategy: value.mitigationStrategy,
    residual_likelihood: RiskScaleValueToJSON(value.residualLikelihood),
    residual_impact: RiskScaleValueToJSON(value.residualImpact),
    residual_exposure: value.residualExposure,
    target_date: value.targetDate,
    review_date: value.reviewDate,
    tags:
      value.tags === undefined
        ? undefined
        : (value.tags as Array<any>).map(TagToJSON),
    associations:
      value.associations === undefined
        ? undefined
        : (value.associations as Array<any>).map(RiskAssociationToJSON),
    verification: RiskVerificationToJSON(value.verification),
    external_id: value.externalId,
    external_url: value.externalUrl,
    issue_manager: value.issueManager,
    created_by: UserToJSON(value.createdBy),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum RiskExposureBandEnum {
  Low = "low",
  Medium = "medium",
  High = "high",
  Critical = "critical",
}
